<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-return-uplevel`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 4a2 2 0 00-1.995 1.85L6 6v36a2 2 0 001.85 1.995L8 44h15a1 1 0 00.993-.883L24 43v-2a1 1 0 00-.883-.993L23 40H10V8h28v13a1 1 0 001 1h2a1 1 0 001-1V5a1 1 0 00-.883-.993L41 4H8zm24.6 18.619a1.4 1.4 0 00-.904.33l-9.433 7.982a1.4 1.4 0 000 2.138l9.433 7.981A1.4 1.4 0 0034 39.981V34h9a1 1 0 001-1v-2a1 1 0 00-1-1h-9v-5.982a1.4 1.4 0 00-1.4-1.4z"/></svg>
</template>
<script>

export default {
  name: 'IconReturnUplevel',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
